export const buildURL = (
  baseURL: string,
  path: string,
  params?: Record<string, unknown> | object,
): string => {
  // Ensure path starts with '/' if it's not empty
  const normalizedPath = path && !path.startsWith("/") ? `/${path}` : path;
  const fullURL = `${baseURL}${normalizedPath}`;

  if (!params) return fullURL;

  const searchParams = new URLSearchParams();

  for (const [key, value] of Object.entries(params)) {
    if (value === undefined || value === null) continue;

    if (Array.isArray(value)) {
      value.forEach((item) => {
        searchParams.append(key, String(item));
      });
    } else if (["string", "number", "boolean"].includes(typeof value)) {
      searchParams.append(key, String(value));
    }
  }

  const queryString = searchParams.toString();

  return queryString ? `${fullURL}?${queryString}` : fullURL;
};
